export const typography = {
  button: {
    fontWeight: 600
  },
  h1: {
    fontWeight: 800,
    fontSize: '4.25rem'
  },
  h2: {
    fontWeight: 600,
    fontSize: '4rem'
  },
  h3: {
    fontWeight: 600,
    fontSize: '2.25rem'
  },
  h4: {
    fontWeight: 600,
    fontSize: '2rem'
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.5rem'
  },
  h6: {
    fontWeight: 600,
    fontSize: 14
  },
  overline: {
    fontWeight: 600
  },
  body1: {
    fontSize: 14
  },
  body2: {
    fontSize: 14
  }
};
